import { NOTIFICATION_STATUS } from '~/models/Notification'
import { API_NOTIFICATION_STATUS } from './apiTypes'

export class NotificationApiMapper {
	public static toNotificationStatus(apiStatus: NOTIFICATION_STATUS): API_NOTIFICATION_STATUS {
		const statusMap: Record<NOTIFICATION_STATUS, API_NOTIFICATION_STATUS> = {
			[NOTIFICATION_STATUS.UNREAD]: API_NOTIFICATION_STATUS.UNREAD,
			[NOTIFICATION_STATUS.READ]: API_NOTIFICATION_STATUS.READ,
		}
		return statusMap[apiStatus]
	}
}
